<!-- 学历信息 -->

<template>
  <div class="applyInitiation_personal applyInitiation_edu">
    <div class="applyInitiation_personal_head">
      <span>学历信息</span>
      <span class="red">(选填)</span>
    </div>
    <div class="applyInitiation_personal_main">
      <ul class="applyInitiation_personal_list clearfix">
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">学历</div>
          <el-select :disabled="isDisabled" v-model="eduFormData.edu_info" placeholder="请选择">
            <el-option v-for="(item, index) in educationList" :key="index" :label="item" :value="item"> </el-option>
          </el-select>
        </li>
        <li class="clearfix graduate">
          <div class="applyInitiation_personal_list_name left">毕业院校</div>
          <el-select :disabled="isDisabled" v-model="eduFormData.edu_school" placeholder="请选择" filterable>
            <el-option v-for="(item, index) in schoolList" :key="index" :label="item.sc_name" :value="item.sc_name"> </el-option>
          </el-select>
        </li>
        <li class="clearfix">
          <div class="applyInitiation_personal_list_name left">专业</div>
          <el-input :disabled="isDisabled" v-model="eduFormData.edu_specialty" placeholder="请输入"></el-input>
        </li>
      </ul>
      <div class="uploadImg_identity_ul clearfix">
        <div class="uploadImg_identity_ul_left">
          <div class="uploadImg_identity_ul_top">
            <input :disabled="isDisabled" type="file" @input="uploadDiplomaImg" />
            <img :src="diplomaImgUrl" alt="" v-if="diplomaImgUrl" />
            <img src="../../../assets/image/apply/1.png" alt="" v-else />
          </div>
        </div>
        <div class="uploadImg_identity_ul_left">
          <div class="uploadImg_identity_ul_top">
            <input :disabled="isDisabled" type="file" @input="uploadCertificateImg" />
            <img :src="certificateImgUrl" alt="" v-if="certificateImgUrl" />
            <img src="../../../assets/image/apply/4.png" alt="" v-else />
          </div>
        </div>
      </div>
      <div class="copy" v-if="!isDisabled" @click="handleSubmitEducation">保存并继续</div>
    </div>
  </div>
</template>

<script>
import $DB from '../../../util/debounce'
import { uploadFile } from '../../../util/upload'

export default {
  name: 'Education',
  props: {
    // 用户信息
    userInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      // 学历信息
      educationInfo: {
        edu_status: 0,
      },

      educationList: [], // 学历列表
      schoolList: [], // 学校列表

      eduFormData: {
        edu_info: '', // 学历
        edu_school: '', // 毕业院校
        edu_diploma: '', // 毕业证书图片 id
        edu_degree: '', // 学位证书图片 id

        // 202407 新增
        edu_specialty: '', // 专业
      },

      diplomaImgUrl: null, //毕业证
      certificateImgUrl: null, //学位证
    }
  },
  computed: {
    isDisabled() {
      return this.userInfo.check_status === 2 || this.userInfo.check_status === 3
    },
  },
  created() {
    this.funLoadEducation()

    // 类型:1性别:2 民族;3身高;4体重:5属相;6星座:7血型;8信仰;9 籍贯;10长期居住地;11学历;12毕业院校【对应School表];13公司类型:14职业:15收入:16兄弟姐妹几人;17婚姻状况:18住房情况:19买车情况:20是否抽烟;21是否喝酒;22是否有孩子;23 有几个孩子:24 是否想要孩子;25 何时结婚;26年龄;27身高;28期待结婚时间;29所在地:30推荐指数;32 工作性质;33住房是否有贷款;34车辆是否有贷款;35父母亲情况;36父母亲工作情况;37父母亲是否有退休金;38是否原生家庭;39感情经历:40孩子情况:41抚养费;
    const obj = {
      11: 'educationList', // 学历列表
    }
    for (const key in obj) {
      this.funLodeCateList(+key, obj[key])
    }
    this.funLoadSchoolList()
  },
  methods: {
    //获取学历信息
    funLoadEducation() {
      this.$axios.post('/api/member/getUserEducate').then((res) => {
        this.educationInfo.edu_status = res.data.data.edu_status
        if (res.data.code === 0) {
          this.diplomaImgUrl = res.data.data.edu_diploma_img
          this.certificateImgUrl = res.data.data.edu_degree_img
          this.educationInfo = res.data.data
          for (const key in this.eduFormData) {
            this.eduFormData[key] = this.educationInfo[key]
          }
        }
      })
    },

    /**
     * 获取下拉选择内容
     * @param {Number} type 类型
     * @param {String} propName data 中的字段名
     */
    funLodeCateList(type, propName) {
      this.$axios.post('/api/index/cateList', { type }).then((res) => {
        if (res.data.code === 0) {
          this[propName] = res.data.data[0].cate_name
        }
      })
    },
    //获取学校列表
    funLoadSchoolList() {
      this.$axios.post('/api/index/schoolList').then((res) => {
        if (res.data.code === 0) {
          this.schoolList = res.data.data.scList
        }
      })
    },

    //上传毕业证照片
    uploadDiplomaImg: $DB(async function (event) {
      if (!event.target.files.length) return

      const fileInfo = event.target.files[0]
      const result = await uploadFile(fileInfo, this)
      this.eduFormData.edu_diploma = result.id
      this.diplomaImgUrl = result.url
    }),
    //上传学位证照片
    uploadCertificateImg: $DB(async function (event) {
      if (!event.target.files.length) return

      const fileInfo = event.target.files[0]
      const result = await uploadFile(fileInfo, this)
      this.eduFormData.edu_degree = result.id
      this.certificateImgUrl = result.url
    }),

    //提交学历信息
    handleSubmitEducation: $DB(function () {
      // if (!this.eduFormData.edu_info) return this.$message.error('请选择学历')
      // if (!this.eduFormData.edu_school) return this.$message.error('请选择毕业院校')
      // if (!this.eduFormData.edu_diploma) return this.$message.error('请上传毕业证照片')
      // if (!this.eduFormData.edu_degree) return this.$message.error('请上传学位证照片')

      this.$axios.post('/api/member/userEducate', this.eduFormData).then((res) => {
        if (res.data.code === 0) {
          this.$message.success(res.data.msg)
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }),
  },
}
</script>

<style lang="scss" src="../index.scss" scoped></style>
